"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontClassification = void 0;
exports.getStyle = getStyle;
exports.getStyleByName = getStyleByName;
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const FontFamilies_1 = __importDefault(require("../styles/FontFamilies"));
const BlackItalicStyle_1 = __importDefault(require("./BlackItalicStyle"));
const BoldItalicStyle_1 = __importDefault(require("./BoldItalicStyle"));
const ExtraBoldItalicStyle_1 = __importDefault(require("./ExtraBoldItalicStyle"));
const ExtraLightItalicStyle_1 = __importDefault(require("./ExtraLightItalicStyle"));
const LightItalicStyle_1 = __importDefault(require("./LightItalicStyle"));
const MediumItalicStyle_1 = __importDefault(require("./MediumItalicStyle"));
const SemiBoldItalicStyle_1 = __importDefault(require("./SemiBoldItalicStyle"));
const ThinItalicStyle_1 = __importDefault(require("./ThinItalicStyle"));
const ThinStyle_1 = __importDefault(require("./ThinStyle"));
const ExtraLightStyle_1 = __importDefault(require("./ExtraLightStyle"));
const LightStyle_1 = __importDefault(require("./LightStyle"));
const RegularItalicStyle_1 = __importDefault(require("./RegularItalicStyle"));
const RegularStyle_1 = __importDefault(require("./RegularStyle"));
const MediumStyle_1 = __importDefault(require("./MediumStyle"));
const SemiBoldStyle_1 = __importDefault(require("./SemiBoldStyle"));
const ExtraBoldStyle_1 = __importDefault(require("./ExtraBoldStyle"));
const BoldStyle_1 = __importDefault(require("./BoldStyle"));
const BlackStyle_1 = __importDefault(require("./BlackStyle"));
const types_1 = require("./types");
const CssVariableHelper_1 = require("../styles/CssVariableHelper");
const NullStyle_1 = __importDefault(require("./NullStyle"));
var FontClassification;
(function (FontClassification) {
    FontClassification["LOCAL"] = "local";
    FontClassification["SERIF"] = "serif";
    FontClassification["SANS_SERIF"] = "sansSerif";
    FontClassification["CUSTOM"] = "custom";
})(FontClassification || (exports.FontClassification = FontClassification = {}));
const thin = new ThinStyle_1.default();
const thinItalic = new ThinItalicStyle_1.default();
const extraLight = new ExtraLightStyle_1.default();
const extraLightItalic = new ExtraLightItalicStyle_1.default();
const light = new LightStyle_1.default();
const lightItalic = new LightItalicStyle_1.default();
const regular = new RegularStyle_1.default();
const regularItalic = new RegularItalicStyle_1.default();
const medium = new MediumStyle_1.default();
const mediumItalic = new MediumItalicStyle_1.default();
const semiBold = new SemiBoldStyle_1.default();
const semiBoldItalic = new SemiBoldItalicStyle_1.default();
const bold = new BoldStyle_1.default();
const boldItalic = new BoldItalicStyle_1.default();
const extraBold = new ExtraBoldStyle_1.default();
const extraBoldItalic = new ExtraBoldItalicStyle_1.default();
const black = new BlackStyle_1.default();
const blackItalic = new BlackItalicStyle_1.default();
const localFonts = [
    {
        family: FontFamilies_1.default.HELVETICA,
        displayFamily: 'Helvetica, Arial, sans serif',
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.LOCAL,
        source: graphql_schema_types_1.FontSource.Local
    },
    {
        family: FontFamilies_1.default.TIMES_NEW_ROMAN,
        displayFamily: 'Times New Roman, serif',
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.LOCAL,
        source: graphql_schema_types_1.FontSource.Local
    }
];
const sansSerifFonts = [
    {
        family: FontFamilies_1.default.ATKINSON,
        styles: [regular, bold],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Server
    },
    {
        family: FontFamilies_1.default.INTER,
        styles: [light, regular, medium, semiBold],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.KARLA,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.KHAND,
        styles: [light, regular, medium, bold],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.KRUB,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.MONTSERRAT,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google,
        previewScalingAdjust: -0.03
    },
    {
        family: FontFamilies_1.default.MONTSERRAT_ALTERNATES,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google,
        previewScalingAdjust: -0.04
    },
    {
        family: FontFamilies_1.default.NOTO_SANS,
        styles: [regular, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.OPEN_SANS,
        styles: [light, regular, semiBold, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.OSWALD,
        styles: [light, regular, medium, bold],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.PT_SANS,
        styles: [regular, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.QUICKSAND,
        styles: [light, regular, medium, bold],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.RALEWAY,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.ROBOTO,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.ROSARIO,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.RUBIK,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.WORK_SANS,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SANS_SERIF,
        source: graphql_schema_types_1.FontSource.Google
    }
];
const serifFonts = [
    {
        family: FontFamilies_1.default.BASKERVILLE,
        styles: [regular, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.BITTER,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.CORMORANT,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.CRIMSON_PRO,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.GENTIUM_BOOK_BASIC,
        styles: [regular, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.NOTO_SERIF,
        styles: [regular, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.PLAYFAIR_DISPLAY,
        styles: [regular, medium, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.QUATTROCENTO,
        styles: [regular, bold],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.ROBOTO_SLAB,
        styles: [light, regular, medium, bold],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.VOLLKORN,
        styles: [regular, medium, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    },
    {
        family: FontFamilies_1.default.ZILLA_SLAB,
        styles: [light, regular, medium, bold, regularItalic],
        classification: FontClassification.SERIF,
        source: graphql_schema_types_1.FontSource.Google
    }
];
/**
 * Filters out invalid fonts.
 *
 * @param source the font source
 */
const fonts = Object.freeze([...localFonts, ...sansSerifFonts, ...serifFonts]);
exports.default = {
    fonts
};
function getStyleMap() {
    return {
        [thin.weight]: thin,
        [extraLight.weight]: extraLight,
        [light.weight]: light,
        [regular.weight]: regular,
        [medium.weight]: medium,
        [semiBold.weight]: semiBold,
        [bold.weight]: bold,
        [extraBold.weight]: extraBold,
        [black.weight]: black
    };
}
function getItalicStyleMap() {
    return {
        [thinItalic.weight]: thinItalic,
        [extraLightItalic.weight]: extraLightItalic,
        [lightItalic.weight]: lightItalic,
        [regularItalic.weight]: regularItalic,
        [mediumItalic.weight]: mediumItalic,
        [semiBoldItalic.weight]: semiBoldItalic,
        [boldItalic.weight]: boldItalic,
        [extraBoldItalic.weight]: extraBoldItalic,
        [blackItalic.weight]: blackItalic
    };
}
function getStyle(weight, fontStyle) {
    let map;
    switch (fontStyle) {
        case graphql_schema_types_1.FontStyle.Italic: {
            map = getItalicStyleMap();
            break;
        }
        default: {
            map = getStyleMap();
        }
    }
    const weightToUse = (0, CssVariableHelper_1.isWrappedCssVariable)(weight) ? (0, CssVariableHelper_1.extractCssVariable)(weight, '400') : weight;
    const mappedValue = map[weightToUse];
    if (!mappedValue) {
        switch (weightToUse) {
            case 'bold': {
                return new BoldStyle_1.default();
            }
            case 'normal': {
                return fontStyle === graphql_schema_types_1.FontStyle.Italic ? new RegularItalicStyle_1.default() : new RegularStyle_1.default();
            }
            case 'lighter': {
                return new LightStyle_1.default();
            }
            case 'bolder': {
                return new ExtraBoldStyle_1.default();
            }
            default: {
                return new NullStyle_1.default();
            }
        }
    }
    return mappedValue;
}
function getStyleByName(fontStyleName) {
    const map = {
        [types_1.FontStyleName.THIN]: thin,
        [types_1.FontStyleName.THINITALIC]: thinItalic,
        [types_1.FontStyleName.EXTRALIGHT]: extraLight,
        [types_1.FontStyleName.EXTRALIGHTITALIC]: extraLightItalic,
        [types_1.FontStyleName.LIGHT]: light,
        [types_1.FontStyleName.LIGHTITALIC]: lightItalic,
        [types_1.FontStyleName.MEDIUM]: medium,
        [types_1.FontStyleName.MEDIUMITALIC]: mediumItalic,
        [types_1.FontStyleName.REGULAR]: regular,
        [types_1.FontStyleName.ITALIC]: regularItalic,
        [types_1.FontStyleName.SEMIBOLD]: semiBold,
        [types_1.FontStyleName.SEMIBOLDITALIC]: semiBoldItalic,
        [types_1.FontStyleName.BOLD]: bold,
        [types_1.FontStyleName.BOLDITALIC]: boldItalic,
        [types_1.FontStyleName.EXTRABOLD]: extraBold,
        [types_1.FontStyleName.EXTRABOLDITALIC]: extraBoldItalic,
        [types_1.FontStyleName.BLACK]: black,
        [types_1.FontStyleName.BLACKITALIC]: blackItalic
    };
    return map[fontStyleName];
}
//# sourceMappingURL=FontDefinitions.js.map